/**
 * Awaits promise and returns boolean depending on if the promise resolved.
 * @returns True if "promise" resolved, false otherwise.
 */
export async function isResolved(promise: Promise<unknown>): Promise<boolean> {
    try {
        await promise
        return true
    } catch {
        return false
    }
}

export function isPromise(value: unknown): value is Promise<unknown> {
    return (
        typeof value === 'object' &&
        value !== null &&
        typeof (value as Promise<unknown>).then === 'function' &&
        typeof (value as Promise<unknown>).catch === 'function' &&
        typeof (value as Promise<unknown>).finally === 'function'
    )
}
